import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { selectTrainersQueryItems } from '../../../../redux/trainers/selector';
import { trainers } from '../../../../redux/trainers/action';
import TrainerComponent from '../components/trainer.component';


const ManagementTrainer= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const trainersItems = useSelector(selectTrainersQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
    const librariesItems = storePersist?.get("library")?.current;

  const [ selectedTrainers, setSelectedTrainers ] = useState<any>([])
    const [
      selectedAddress,
      setSelectedAddress
    ] = useState<any>({
  
      PrimaryAddress: {},
      
  
    })
 
  const fetchTrainersQueryById= ()=>{
    
    dispatch(trainers.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/trainers/query`,entity:'trainers',jsonData:{
    Records: [
      {   
              "Id": parmas?.id      
      }
    ]
  
  }})).then(()=>{
    setIsQuery(true)
  })

  }


  
 

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedTrainers({ ...selectedTrainers, [fields[0]]: value });
      setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  useEffect(
    () => {
     
      
      if (parmas?.id > 0) {
        fetchTrainersQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }    
    
     
    },
    []
  )

  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedTrainers(trainersItems?.result?.items)
      }
    },
    [isQuery]
  )
  
  

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(trainers.resetAction({ actionType: 'update' }))
      await dispatch(trainers.update({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/trainers`,
      entity:'trainers',
      jsonData:{
          
    Records: [
      {
         ...selectedTrainers

      }
      
    ]
 
    }})).then(()=>{
      back()
    })

    }else{
      await dispatch(trainers.resetAction({ actionType: 'create' }))
      await dispatch(trainers.create({
        url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/trainers`,
        entity:'trainers',
        jsonData:{
          
      Records: [
        { 
            ...selectedTrainers
      }
      ]
    
    }})).then(()=>{
      back()
    })
    }
   
  }

  const back=()=>{
    navigate('/management/e-applications/onesp/trainers')
  } 
    return (
      <>
        {isLoading ? <PageLoader /> :
        <TrainerComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectedTrainers={selectedTrainers}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
          selectedAddress={selectedAddress}
          
  
          
        />  
    }
      </>
    )
    
    }
   
    export default ManagementTrainer;